/*
 * SwitchButtonComponent Class
 *
 * A dynamic switch button component that generates buttons based on an array of objects.
 * Each button has a `data-lang` attribute for translations and can trigger a callback on click.
 *
 * Usage:
 * const buttonsConfig = [
 *     { label: 'Visitors', lang: 'en-visitors' },
 *     { label: 'Friends', lang: 'en-friends' },
 *     { label: 'Family', lang: 'en-family' }
 * ];
 *
 * const mySwitch = new SwitchButtonComponent('#mySwitch', buttonsConfig, (index, buttonConfig) => {
 *     console.log('Button clicked:', index, buttonConfig);
 * });
 *
 * Parameters:
 * - containerSelector: String - Selector for the container element.
 * - buttonsConfig: Array - Configuration array for the buttons (label and lang).
 * - onButtonClickCallback: Function - Callback function triggered on button click.
 */
export default class SwitchButtonComponent {
  constructor(containerSelector, buttonsConfig, onButtonClickCallback) {
    this.container = $(containerSelector);
    this.buttonsConfig = buttonsConfig;
    this.callback = onButtonClickCallback;

    this.init();
  }

  init() {
    // Clear existing buttons in the container
    this.container.empty();

    // Dynamically create buttons from the configuration array
    this.buttonsConfig.forEach((buttonConfig, index) => {
      const selected = buttonConfig.selected ? "selected" : "";
      const disabled = buttonConfig.disabled ? "selected" : "";
      const button = $(`<div class="switch-button ${selected} ${disabled}" data-name="${buttonConfig.name}" data-index="${index}" data-lang="${buttonConfig.lang}">
                        ${buttonConfig.label}
                    </div>`);
      this.container.append(button);
    });

    // Add click event listeners to the buttons
    this.buttons = this.container.find('.switch-button');
    this.buttons.on('click', (event) => {
      const clickedButton = $(event.currentTarget);
      this.buttons.removeClass('selected');
      clickedButton.addClass('selected');

      const index = clickedButton.data('index');
      if (this.callback && typeof this.callback === 'function') {
        this.callback(index, this.buttonsConfig[index]);
      }
    });
  }
}